<template>
  <div class="app-title_wrapper">
    <router-link
      class="app-title"
      :to="{ name: 'Root' }"
    >
      <img
        :width="isMiniVariant ? '32' : '150'"
        :alt="`${appName} ${appSubname} logo`"
        :src="isMiniVariant ? companyLogoImgMiniSrc : companyLogoImgSrc"
      >
    </router-link>
    <BackArrow @toggle-mini-variant="$emit('toggle-mini-variant')" />
  </div>
</template>

<script>
import BackArrow from '@/components/Main/SideNavigation/SideNavigationBackArrow.vue'

export default {
  components: {
    BackArrow,
  },
  props: {
    isMiniVariant: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    appName() {
      return this.$envConfig.webtritAppName
    },
    appSubname() {
      return this.$envConfig.webtritAppSubname
    },
    companyLogoImgSrc() {
      return this.$envConfig.webtritCompanyLogoImgSrc || require('@/assets/logo.png')
    },
    companyLogoImgMiniSrc() {
      return require('@/assets/favicon-32x32.png')
    },
  },
}
</script>

<style lang="scss" scoped>
.app-title_wrapper {
  @apply flex flex-nowrap;
}

.app-title {
  @apply flex justify-center items-center my-5 w-max mx-auto;
  @apply text-white no-underline #{!important};
}

.mini {
  .app-title {
    @apply mr-0;
  }
}
</style>
